import React, { useState } from "react";
import FsLightbox from "fslightbox-react";
import "../../../App.css"
import image1 from "../../../Img/Proyectos/ProyectosTurismo/VillaBelHa/01 PORTADA.jpg"
import image2 from "../../../Img/Proyectos/ProyectosTurismo/VillaBelHa/villa-belha-riviera-maya-1-10.jpg"
import image3 from "../../../Img/Proyectos/ProyectosTurismo/VillaBelHa/villa-belha-riviera-maya-1-16.jpg"
import image4 from "../../../Img/Proyectos/ProyectosTurismo/VillaBelHa/villa-belha-riviera-maya-1-21.jpg"
import image5 from "../../../Img/Proyectos/ProyectosTurismo/VillaBelHa/villa-belha-riviera-maya-1-27.jpg"
import image6 from "../../../Img/Proyectos/ProyectosTurismo/VillaBelHa/villa-belha-riviera-maya-1-3.jpg"
import image7 from "../../../Img/Proyectos/ProyectosTurismo/VillaBelHa/villa-belha-riviera-maya-1-31.jpg"
import image8 from "../../../Img/Proyectos/ProyectosTurismo/VillaBelHa/villa-belha-riviera-maya-1-40.jpg"
import image9 from "../../../Img/Proyectos/ProyectosTurismo/VillaBelHa/villa-belha-riviera-maya-1-8.jpg"
import image10 from "../../../Img/Proyectos/ProyectosTurismo/VillaBelHa/villa-belha-riviera-maya-1-47.jpg"
import image11 from "../../../Img/Proyectos/ProyectosTurismo/VillaBelHa/villa-belha-riviera-maya-1-52.jpg"
import image12 from "../../../Img/Proyectos/ProyectosTurismo/VillaBelHa/villa-belha-riviera-maya-1-54.jpg"
import image13 from "../../../Img/Proyectos/ProyectosTurismo/VillaBelHa/villa-belha-riviera-maya-1-7.jpg"


import { Helmet } from "react-helmet";

function VillaBelHa() {
    
    const [lightboxController, setLightboxController] = useState({
        toggler: false,
        slide: 1
    });

    function openLightboxOnSlide(number) {
        setLightboxController({
            toggler: !lightboxController.toggler,
            slide: number
        });
    }


    return (
        <>

            <Helmet>
                <title>Hoteles - Villa Bel-Ha</title>
            </Helmet>

            <FsLightbox
                toggler={lightboxController.toggler}

                sources={[
                    image1, image2, image3, image4, image5, image6, image7, image8, image9, image10, image11, image12, image13
                ]}

                slide={lightboxController.slide}
            />

            <div className="container col-12 py-5">
                <div className="d-flex">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/proyectos-turismo">Hoteles</a></li>
                            <li class="breadcrumb-item active" aria-current="page">Proyecto Bucerias</li>
                        </ol>
                    </nav>
                </div>
                <h1 className="py-2 m-0 p-0">Proyecto Villa Bel-Ha</h1>
                <h6 className="py-2 m-0 p-0">Playa Xpu-Ha, QR.<h6>2002</h6></h6>
            </div>

            <div className="container position-relative">
                <img onClick={() => openLightboxOnSlide(1)} type="button" src={image1} className="w-100" alt="..." height={650} />
            </div>


            <div className="container">
                <div className="row gy-4 mt-1">

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(2)}
                            src={image2}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(3)}
                            src={image3}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(4)}
                            src={image4}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(5)}
                            src={image5}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(6)}
                            src={image6}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(7)}
                            src={image7}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(8)}
                            src={image8}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(9)}
                            src={image9}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    
                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(10)}
                            src={image10}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(11)}
                            src={image11}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(12)}
                            src={image12}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(13)}
                            src={image13}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                </div>
            </div>
        </>
    );
}

export default VillaBelHa;
